import React from 'react';

// Premium Dark–Neon Testimonial Card
const CardTes = ({
  quote = 'Craft Tech transformed our vision into reality. Their attention to details and technical expertise is unmatched. The platform they built has been instrumental in our 300% growth.',
  name = 'Sarah Johnson',
  title = 'CEO, TechStart Inc',
  avatarImage,
  rating = 5,
}) => {
  const renderStars = (count) =>
    Array.from({ length: 5 }).map((_, i) => (
      <span
        key={i}
        className={`text-xl ${i < count ? 'text-[#00FF88]' : 'text-[#00FF88]/30'}`}
      >
        ★
      </span>
    ));

  return (
    <div
      className="
        relative
        p-8
        w-full
        h-full
        text-white
        flex flex-col
        rounded-3xl
        border border-white/10
        bg-gradient-to-br from-[#0B1F2A] via-[#0E2F3C] to-[#0A1A22]
        hover:shadow-[0_0_40px_rgba(0,255,136,0.15)]
        transition duration-300
        overflow-hidden
      "
    >
      {/* Neon Glow Accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#00FF88]/10 to-transparent opacity-60 pointer-events-none" />

      {/* Quote Icon */}
      <div className="text-7xl font-extrabold text-[#00FF88]/30 leading-none -mt-4 mb-2 z-10">&ldquo;</div>

      {/* Rating */}
      <div className="flex space-x-1 mb-4 z-10">{renderStars(rating)}</div>

      {/* Quote Text */}
      <p className="text-white/80 text-base leading-relaxed mb-6 z-10 line-clamp-4">
        “{quote}”
      </p>

      {/* Client Info */}
      <div className="flex items-center mt-auto pt-6 border-t border-white/10 z-10">
        <div className="w-14 h-14 rounded-full mr-4 overflow-hidden bg-gradient-to-br from-[#00FF88] to-[#00CFFF] p-[2px]">
          <div
            className="w-full h-full rounded-full bg-[#0B1F2A]"
            style={{
              backgroundImage: avatarImage ? `url(${avatarImage})` : 'none',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        </div>

        <div className="flex flex-col">
          <p className="font-semibold text-lg">{name}</p>
          <p className="text-sm text-white/60">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default CardTes;